/* eslint-disable import/prefer-default-export */
import { IntegrationCategoryParam, IntegrationCategory, IntegrationItem } from '../../model'

type CategoryGroup = {
  label: string
  value: IntegrationCategoryParam
  integrations: IntegrationItem[]
}

export function groupIntegrationsByCategory(
  integrations: IntegrationItem[],
  categories: IntegrationCategory[]
): CategoryGroup[] {
  const groupMap = integrations.reduce<Record<string, IntegrationItem[]>>((acc, integration) => {
    if (!acc[integration.category]) acc[integration.category] = [integration]
    else acc[integration.category].push(integration)
    return acc
  }, {})

  return Object.entries(groupMap).reduce<CategoryGroup[]>((acc, [type, integrations]) => {
    const category = categories.find(({ value }) => value === type)

    if (category) {
      acc.push({
        label: category.label,
        value: category.value,
        integrations,
      })
    }

    return acc
  }, [])
}
